// extracted by mini-css-extract-plugin
module.exports = {"image":"PhotoList_image__m_4Hy"};